import { useRef } from "react";
import { motion, useScroll, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";

const COLORS = ["#149B9E", "#FFC20E", "#FF6B6B"];

export const StepsPath = ({ steps }) => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  return (
    <div ref={ref} className="relative mt-14" data-testid="steps-path">
      <div aria-hidden className="absolute left-5 top-0 bottom-0 w-px bg-black/10 md:left-0 md:right-0 md:top-7 md:bottom-auto md:h-px md:w-auto" />
      <motion.div aria-hidden data-testid="steps-path-line" className="absolute left-5 top-0 bottom-0 w-[3px] origin-top -translate-x-px rounded-full bg-gradient-to-b from-en-teal via-en-yellow to-[#FF6B6B] md:left-0 md:right-0 md:top-7 md:bottom-auto md:h-[3px] md:w-auto md:origin-left md:translate-x-0 md:bg-gradient-to-r" style={reduced ? {} : { scaleY: scrollYProgress, scaleX: scrollYProgress }} />
      <ol className="grid gap-10 md:grid-cols-3 md:gap-6">
        {steps.map((s, i) => {
          const c = COLORS[i % COLORS.length];
          return (
            <li key={s.step} className="relative pl-16 md:pl-0 md:pt-20" data-testid={`step-${i}`}>
              <Reveal delay={0.15 * i} className="absolute left-5 top-0 -translate-x-1/2 md:left-7 md:top-7 md:-translate-y-1/2">
                <span className="relative flex h-14 w-14 items-center justify-center rounded-full font-display text-xl text-white shadow-lg" style={{ background: c }}>
                  <span aria-hidden className="step-ripple absolute inset-0 rounded-full border-2" style={{ borderColor: c, "--i": i }} />
                  {s.step}
                </span>
              </Reveal>
              <Reveal delay={0.15 * i + 0.1} className="card-white h-full p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-2" style={{ borderTop: `4px solid ${c}` }}>
                <h3 className="font-display text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-black/70">{s.desc}</p>
              </Reveal>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
